import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WatchList, { FAVORITE_PLUS_HOVER, FAVORITE_TYPE_WATCHLIST } from 'components/Favorite';
import { WatchlistPosterProcessor } from '../../processors/index';
import { SimplifiedImage, HoverStateToolTip, Overlay } from '../../components';
import Style from './WatchlistPoster.module.scss';

const WatchlistPoster = ({
  breakpoint,
  checkedItems,
  favoritesManager,
  isGrid,
  isMobileEditActive,
  item,
  itemIndex,
  preventLazyLoad,
  segmentPlaylistButtonAction,
  setCheckedItems,
}) => {
  const [isFavorite, setFavorite] = useState(false);
  const {
    link: route,
    onPosterClick,
    posterAltText,
    posterImage,
    badge,
    name,
    overlayProps,
  } = WatchlistPosterProcessor({ item });
  const { description } = item;
  const getCarouselPosterClasses = [];
  const favorites = favoritesManager?.favorites;
  const favoriteData = overlayProps?.favoriteData;
  const isChecked = !!checkedItems.filter(item => item.showID === favoriteData.showID)?.length;

  useEffect(() => {
    const isFavorite = () => {
      let results = [];
      if (!favorites) return false;
      favoriteData?.favoritableItems?.forEach(item => {
        const matches = favorites?.filter(favorite => item.id === favorite.favoriteID);
        results = [...matches, ...results];
      });
      return results.length > 0;
    };
    setFavorite(isFavorite());
  }, [favoriteData, favorites]);

  if (isGrid) {
    getCarouselPosterClasses.push(Style.gridPoster);
  }

  const onCheckboxChange = useCallback(() => {
    setCheckedItems(items => {
      const filteredItems = items.filter(item => item.showID === favoriteData.showID);
      if (filteredItems?.length) {
        return items.filter(item => item.showID !== favoriteData.showID);
      }
      return [...items, favoriteData];
    });
  }, [favoriteData, setCheckedItems]);

  const posterImageProps = {
    badge,
    breakpoint,
    image: posterImage,
    isGrid,
    item,
    onPosterClick,
    posterAltText: posterAltText || name,
    preventLazyLoad,
    route,
    theme: Style,
  };

  return (
    <div className={classNames(getCarouselPosterClasses)} key={itemIndex}>
      <SimplifiedImage {...posterImageProps} />
      {favoritesManager && (
        <Overlay theme={Style}>
          {isMobileEditActive && (
            <label className={Style.mobileCheckboxLabel}>
              <div className={Style.mobileCheckboxRound}>
                <input
                  checked={isChecked}
                  onChange={onCheckboxChange}
                  className={Style.mobileCheckbox}
                  type="checkbox"
                />
              </div>
            </label>
          )}
          <span className={Style.watchList}>
            <span className={Style.watchListButtonContainer}>
              <WatchList
                type={FAVORITE_TYPE_WATCHLIST}
                stopNavigationOnClick
                manager={favoritesManager}
                iconType={FAVORITE_PLUS_HOVER}
                setFavorite={setFavorite}
                favorites={favorites}
                data={{ ...favoriteData, titleText: name, subtitleText: description }}
                segmentPlaylistButtonAction={segmentPlaylistButtonAction}
              />
            </span>
            <HoverStateToolTip theme={Style} isFavorited={isFavorite} isRightJustified />
          </span>
        </Overlay>
      )}
    </div>
  );
};

WatchlistPoster.propTypes = {
  account: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  checkedItems: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({}),
  isGrid: PropTypes.bool,
  isMobileEditActive: PropTypes.bool,
  isPersonality: PropTypes.bool,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  preventLazyLoad: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
  setCheckedItems: PropTypes.func,
};

export default WatchlistPoster;
